import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-inflamacion',
  templateUrl: './inflamacion.component.html',
  styleUrls: []
})
export class InflamacionComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="¿Gases o inflamación? Fortalece tu salud digestiva | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"¿Gases o inflamación? Fortalece tu salud digestiva | Sinuberase",
  		description: "Toma Sinuberase y combate la inflamación. Los estudios publicados muestran una reducción de la distensión abdominal y la flatulencia con tratamientos probióticos",
  		slug: "Inflamacion"
  	})
  	this.seo.closeMenu();
  }

}
